
// Slugs = Prismic-UIDs der sport_page-Dokumente je Sprache
const SPORTS = [
  { icon: '⚽', label: 'Fußball', slug: { de: 'fussball', en: 'soccer' } },
  { icon: '🏑', label: 'Hockey', slug: { de: 'feldhockey', en: 'field-hockey' } },
  { icon: '🏒', label: 'Eishockey', slug: { de: 'eishockey', en: 'ice-hockey' } },
  { icon: '🤾', label: 'Handball', slug: { de: 'handball', en: 'handball' } },
  { icon: '🏀', label: 'Basketball', slug: { de: 'basketball', en: 'basketball' } },
  { icon: '🎾', label: 'Padel', slug: { de: 'padel', en: 'padel' } },
]
 
export default {
  name: 'LayoutHeader',
  data() {
    return {
      mobileMenuOpen: false,
      sports: SPORTS,
    }
  },
  methods: {
    sportPath(sport) {
      const slug = sport.slug[this.$i18n.locale] || sport.slug.de
      // DE: /sport/<slug>/  ·  EN: /en/sports/<slug>/
      return this.$i18n.locale === 'de'
        ? `/sport/${slug}/`
        : `/${this.$i18n.locale}/sports/${slug}/`
    },
  },
}
